const create = (api) => {
    const getTotalScannerTypes = (siteId, startDate, endDate) => {
        return api.get(`/dashboard/v2/deviceutilization/totalscannertypes/${siteId}?startDate=${startDate}&endDate=${endDate}`)
    }

    const getTotalScannerTypesDetails = (siteId, startDate, endDate, searchTerm, sort='serialNumber', directionSort=1, pageNumber=1, pageSize=100) => {
        const query = searchTerm === undefined ? `&query=` : `&query=${searchTerm}`
        return api.get(`/dashboard/v2/deviceutilization/totalscannertypesdetails/${siteId}?startDate=${startDate}&endDate=${endDate}&sort=${sort}&directionSort=${directionSort}`+ `${query}` +`&pageNumber=${pageNumber}&pageSize=${pageSize}`)
    }

    const getExportDeviceCVSFile = (siteId, payload, params, startDate, endDate) =>
        api.post(`/dashboard/exportfiles/${siteId}?startDate=${startDate}&endDate=${endDate}`, payload, { params });

    return {
        getTotalScannerTypes,
        getTotalScannerTypesDetails,
        getExportDeviceCVSFile
    }

}

export default {
    create
}